//
// Original collection by Kjetil Midtgarden Golid
// https://github.com/kgolid/chromotome
// https://kgolid.github.io/chromotome-site/
//
export default [
  {
    name: 'rohlfs_1R',
    colors: ['#004996', '#567bae', '#ff4c48', '#ffbcb3'],
    stroke: '#004996',
    background: '#fff8e7',
    type: 'rohlfs',
  },
  {
    name: 'rohlfs_1Y',
    colors: ['#004996', '#567bae', '#ffc000', '#ffdca4'],
    stroke: '#004996',
    background: '#fff8e7',
    type: 'rohlfs',
  },
  {
    name: 'rohlfs_1G',
    colors: ['#004996', '#567bae', '#60bf3c', '#d2deb1'],
    stroke: '#004996',
    background: '#fff8e7',
    type: 'rohlfs',
  },
  {
    name: 'rohlfs_2',
    colors: ['#4d3d9a', '#f76975', '#ffffff', '#eff0dd'],
    stroke: '#211029',
    background: '#58bdbc',
    type: 'rohlfs',
  },
  {
    name: 'rohlfs_3',
    colors: ['#abdfdf', '#fde500', '#58bdbc', '#eff0dd'],
    stroke: '#211029',
    background: '#f76975',
    type: 'rohlfs',
  },
  {
    name: 'rohlfs_4',
    colors: ['#fde500', '#2f2043', '#f76975', '#eff0dd'],
    stroke: '#211029',
    background: '#fbbeca',
    type: 'rohlfs',
  },
];
